<section [ngClass]="isSticky === true ? 'sticky stickTotal d-block' : 'd-none'">
  <div class="">
    <div class="savings-total flu-savings-total">
      <p class="flu-savings-txt">
        {{ totalUnits }} Units | {{ totalDoses }} Doses
      </p>

      <h3>
        Estimated total:
        {{
        reservationDetails?.totalPriceWithTax?.value
        | currency: "USD":"symbol":"1.2-2"
        }}
      </h3>
      <p class="flu-savings-txt">
        Estimated savings:
        <span class="green">
          {{estimatedSavings}}
        </span>
      </p>
      <p class="flu-savings-txt"></p>
    </div>
    <div class="row table-total-display">
      <div class="col-md-12">
        <table class="estimation-table" role="presentation w-100">
          <tbody>
            @if (reservationDetails?.subTotal?.value) {
              <tr>
                <td class="bold">Subtotal</td>
                <td class="right">
                  {{
                  reservationDetails?.subTotal?.value
                  | currency: "USD":"symbol":"1.2-2"
                  }}
                </td>
              </tr>
            }
            @if (reservationDetails?.totalSalesTaxPrice?.value != 0) {
              <tr>
                <td>Sales tax</td>
                <td class="right">
                  {{
                  reservationDetails?.totalSalesTaxPrice?.value
                  | currency: "USD":"symbol":"1.2-2"
                  }}
                </td>
              </tr>
            }

            @if (reservationDetails?.totalExciseTax?.value != 0) {
              <tr>
                <td>Excise tax<sup class="numberflu">1</sup></td>
                <td class="right">
                  {{
                  reservationDetails?.totalExciseTax?.value
                  | currency: "USD":"symbol":"1.2-2"
                  }}
                </td>
              </tr>
            }

            @if (reservationDetails?.totalOtherDiscount?.value != 0) {
              <tr>
                <td>Direct Savings</td>
                <td class="right green">
                  {{
                  reservationDetails?.totalOtherDiscount?.value
                  | currency: "USD":"symbol":"1.2-2"
                  }}
                </td>
              </tr>
            }

            @if (reservationDetails?.totalWebDiscount?.value != 0) {
              <tr>
                <td>Online Savings<sup class="numberflu">2</sup></td>
                <td class="right green">
                  {{
                  reservationDetails?.totalWebDiscount?.value
                  | currency: "USD":"symbol":"1.2-2"
                  }}
                </td>
              </tr>
            }

            <tr class="bg-color bgborder">
              <td class="bold">Total</td>
              <td class="right">
                {{
                reservationDetails?.totalPriceWithTax?.value
                | currency: "USD":"symbol":"1.2-2"
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>


<div class="influenza-step1 influenza-details influenza-overview printoverviewpage">
  <div class="row row-20 checkout" id="leftCont-rightNav">

    <section class="
        col-sm-12 col-md-7 col-lg-8
        left-section
        float-left
        cart-left
        flu-wrapper
        flushipmentsgraphview
        overview-section
      ">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 flu-wrapper-title">
          <h3 class="title-new shipments">My shipments</h3>
          @if (stsFlag) {
            <button type="button" (click)="scheduleShipments()"
            class="shipping-schedule view-shipments-btn float-right">Schedule Shipments</button>
          }
        </div>
      </div>

      <div class="row chart-table chart-flu-dsh">
        <div class="col-md-12">
          <!--Pie chart Section, XLS starts-->
          <!--below ouput only valid and used for STS-shipped case-->
          <app-flu-charts (manageSts)="manageSts($event)"></app-flu-charts>

          <!--Right side table ends-->
        </div>

        <div class="chart_data">
          <div class="col-md-12 p0">
            <h3 class="title-new-presentation">My presentations</h3>
          </div>
        </div>
        <div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            chart_data
            Fields-container
            account-detailsflu
          ">
          <div class="row bank-details">
            <div class="col-xs-3 col-sm-1 col-md-1 col-lg-1 p0 edit-option pl"></div>
            <div class="
                col-xs-9 col-sm-11 col-md-4 col-lg-4
                p0
                edit-option
                pl
                flureserveoview
              "></div>
          </div>
        </div>
        @for (pcode of reservationDetailsProducts; track pcode; let i = $index) {
          @for (entry of reservationDetailsEntries[0][pcode]; track entry; let j = $index) {
<div class="
            col-xs-12 col-sm-12 col-md-12
            p0
            Fields-container
            account-detailsflu
            presentation
          ">
              <div class="row product-detail-info">
              <div class="
                col-12
                p0
                edit-option
                pd_data
                pl
                mt-3
              ">
                  @if (j==0) {
                    <div class="col-12 field-value p0">
                      <h3 class="img-desc">
                        <a class="cart_title alignrow linealign" (click)="productDetails(entry?.product)">
                          @for (variant of entry?.product?.variantOptions; track variant) {
                            <p>
                              @if (variant?.code === entry?.product?.code) {
                                <span [innerHTML]="variant?.description"></span>
                              }
                            </p>
                          }
                        </a>
                      </h3>
                  <p class="
                    light-blue
                    hidden-sm hidden-md hidden-lg
                    smflu
                    title-smflu
                    bold
                  ">
                        No preservatives <span class="red">Waitlist</span>
                      </p>
                      <p class="smflu title-smflu">
                        <span class="bold-text">{{ entry?.product?.code }}</span>
                        <span class="light-text">| {{ entry?.product?.manufacturer }}</span>
                      </p>
                    </div>
                  }
                </div>
              </div>
              <div class="row bank-details">
                <table class="display pt-history alignrow taalign table-details tableSmHide">
                  @if (j==0) {
                    <thead>
                      <tr class="heading talign">
                        <th id="table1col1" class="tpalign">Contract Group</th>
                        <th id="table1col1" class="pralign tpalign">Units/Doses</th>
                        <th id="table1col1" class="tpalign">Your Price</th>
                        <th id="table1col1" class="tpalign">Direct Savings</th>
                        <th id="table1col1" class="tpalign">Online Savings</th>
                        <th id="table1col1" class="tpalign">Final Price</th>
                      </tr>
                    </thead>
                  }
                  <tbody class="datatable-row">
                    <tr>
                      <td headers="table1col1" class="loc_first cgalign">
                        {{ entry?.contractName }}
                      </td>
                      <td headers="table1col1" class="loc_first pralign">
                        {{ entry?.quantity }}/{{
                        entry?.quantity * entry?.product?.quantityPerUnit
                        }}
                      </td>
                      <td headers="table1col1" class="loc_first total total-amount">
                        {{ ((entry?.basePrice?.value)*entry?.quantity) | currency : 'USD' : 'symbol' :'1.2-2'}}
                      </td>
                      <td headers="table1col1" class="loc_first green total-amount">
                        {{
                        entry?.otherDiscounts?.value
                        | currency: "USD":"symbol":"1.2-2"
                        }}
                      </td>
                      <td headers="table1col1" class="loc_first green total-amount">
                        {{
                        entry?.webDiscount?.value
                        | currency: "USD":"symbol":"1.2-2"
                        }}
                      </td>
                      <td headers="table1col1" class="loc_first total-amount">
                        {{
                        ((entry?.basePrice?.value)*entry?.quantity) + entry?.otherDiscounts?.value +
                        entry?.webDiscount?.value
                        | currency: "USD":"symbol":"1.2-2"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-12 d-lg-none d-md-none d-xl-none tableSmShow p-0 mt-2">
                  <div class="col-12 p-0 divReservation">
                    <div class="d-flex">
                      <div class="col-7 pl-0">
                        <label class="fw-bold">Contract Group</label>
                      </div>
                      <div class="statusTd col-5 pr-0 m-auto">
                        {{ entry?.contractName }}
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="col-7 pl-0">
                        <label class="fw-bold">Units/Doses</label>
                      </div>
                      <div class="sm-value col-5 pr-0 m-auto">{{ entry?.quantity }}/{{
                        entry?.quantity * entry?.product?.quantityPerUnit
                      }}</div>
                    </div>
                    <div class="d-flex">
                      <div class="col-7 pl-0">
                        <label class="fw-bold">Your Price</label>
                      </div>
                      <div class="sm-value col-5 pr-0 m-auto">{{ ((entry?.basePrice?.value)*entry?.quantity) | currency :
                      'USD' : 'symbol' :'1.2-2'}}</div>
                    </div>
                    <div class="d-flex">
                      <div class="col-7 pl-0">
                        <label class="fw-bold">Direct Savings</label>
                      </div>
                      <div class="statusTd col-5 pr-0 m-auto">
                        {{
                        entry?.otherDiscounts?.value
                        | currency: "USD":"symbol":"1.2-2"
                        }}
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="col-7 pl-0">
                        <label class="fw-bold">Online Savings</label>
                      </div>
                      <div class="statusTd col-5 pr-0 m-auto">
                        {{
                        entry?.webDiscount?.value
                        | currency: "USD":"symbol":"1.2-2"
                        }}
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="col-7 pl-0">
                        <label class="fw-bold">Final Price</label>
                      </div>
                      <div class="statusTd col-5 pr-0 m-auto">
                        {{
                        ((entry?.basePrice?.value)*entry?.quantity) + entry?.otherDiscounts?.value +
                        entry?.webDiscount?.value
                        | currency: "USD":"symbol":"1.2-2"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
          }
        }
        <br />

        <div class="row pdflu">
          <div class="col-md-12 col-xs-12 col-sm-12 p-0">
            <h3 class="title-new activity">Activity</h3>
          </div>
          <table class="fluoverview-table2 display mobile-view" id="example1Flu">
            <tbody class="datatable-row">
              @for (activity of activityList; track activity) {
                <tr>
                  <td>{{ activity?.activityDate |date: "MM/dd/yyyy"}}</td>
                  <td>
                    <span>{{ activity?.activityStatus }} </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <aside class="col-sm-12 col-md-5 col-lg-4 right-navigation float-right fluovrviewct">
      <div class="" [ngClass]="isSticky === true ? 'd-none' : 'd-block'">
        <div class="savings-total flu-savings-total w-100 m-0">
          <p class="flu-savings-txt">
            {{ totalUnits }} Units | {{ totalDoses }} Doses
          </p>

          <h3>
            Estimated total:
            {{
            total
            | currency: "USD":"symbol":"1.2-2"
            }}
          </h3>
          <p class="flu-savings-txt">
            Estimated savings:
            <span class="green">
              {{estimatedSavings}}
            </span>
          </p>
          <p class="flu-savings-txt"></p>
        </div>
        <div class="row table-total-display">
          <div class="col-md-12">
            <table class="estimation-table" role="presentation">
              <tbody>
                @if (reservationDetails?.subTotal?.value) {
                  <tr>
                    <td class="bold">Subtotal</td>
                    <td class="right">
                      {{
                      subTotal
                      | currency: "USD":"symbol":"1.2-2"
                      }}
                    </td>
                  </tr>
                }

                @if (reservationDetails?.totalSalesTaxPrice?.value > 0) {
                  <tr>
                    <td>Sales tax</td>
                    <td class="right">
                      {{
                      reservationDetails?.totalSalesTaxPrice?.value
                      | currency: "USD":"symbol":"1.2-2"
                      }}
                    </td>
                  </tr>
                }

                @if (reservationDetails?.totalExciseTax?.value != 0) {
                  <tr>
                    <td>Excise tax<sup class="numberflu">1</sup></td>
                    <td class="right">
                      {{
                      reservationDetails?.totalExciseTax?.value
                      | currency: "USD":"symbol":"1.2-2"
                      }}
                    </td>
                  </tr>
                }

                @if (reservationDetails?.totalOtherDiscount?.value != 0) {
                  <tr>
                    <td>Direct Savings</td>
                    <td class="right green">
                      {{
                      reservationDetails?.totalOtherDiscount?.value
                      | currency: "USD":"symbol":"1.2-2"
                      }}
                    </td>
                  </tr>
                }

                @if (reservationDetails?.totalWebDiscount?.value != 0) {
                  <tr>
                    <td>Online Savings<sup class="numberflu">2</sup></td>
                    <td class="right green">
                      {{
                      reservationDetails?.totalWebDiscount?.value
                      | currency: "USD":"symbol":"1.2-2"
                      }}
                    </td>
                  </tr>
                }

                <tr class="bg-color bgborder">
                  <td class="bold">Total</td>
                  <td class="right">
                    {{
                    total
                    | currency: "USD":"symbol":"1.2-2"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <hr class="light-line" />
      <!--Details-->
      <div class="
          contact-details
          detailsflu
          credit-return
          contact_resv
          sanofi-details-edit
        ">
        <h3>Details</h3>
        <div class="row res_contact details_sucess" [ngClass]="isEdit === true ? 'hide' : ''">
          <div class="col-md-6 details-section w-50">
            <input id="purchaseOrderNumberSec" name="purchaseOrderNumberSec" type="hidden"
              value="reservationDetails.purchaseOrderNumber" />
            <ul>
              <li>
                <h5 class="fs-12 dark-color ff-bold mt0">PO#</h5>
                <p class="ponum">
                  {{ reservationDetails?.purchaseOrderNumber }}
                </p>
              </li>
            </ul>
            <ul>
              <li>
                <h5 class="fs-12 dark-color ff-bold mt0 sub-header">Sold to</h5>
                <p class="w-100">
                  Account #:&nbsp;
                  {{ reservationDetails?.shipToParty?.soldToAddress?.accountNumber }}<br />
                  @if (reservationDetails?.shipToParty?.soldToAddress?.companyName) {
                    <span
                    >{{reservationDetails?.shipToParty?.soldToAddress?.companyName}}<br /></span>
                  }
                  {{ reservationDetails?.shipToParty?.soldToAddress?.formattedAddress }}
                </p>
              </li>
              <li class="hide">
                <h5 class="fs-12 dark-color ff-bold mt0">Reservation date</h5>
                <p>11/06/2021</p>
              </li>
            </ul>
          </div>
          <div class="col-md-5 instructions-section p-0 w-50 pl-2">
            <ul>
              <li>
                <h5 class="fs-12 dark-color ff-bold mt0">Ship to</h5>
                <p class="w-100">
                  Account #:&nbsp;
                  {{
                  reservationDetails?.shipToParty?.shippingAddress
                  ?.accountNumber
                  }}<br />
                  @if (reservationDetails?.shipToParty?.shippingAddress?.companyName) {
                    <span>
                      {{reservationDetails?.shipToParty?.shippingAddress?.companyName}}
                      <br />
                    </span>
                  }

                  {{
                  reservationDetails?.shipToParty?.shippingAddress
                  ?.formattedAddress
                  }}
                </p>
              </li>
              <li>
                <h5 class="fs-12 dark-color ff-bold mt0 attention sub-header">
                  Attention
                </h5>
                <p class="atenline">{{ reservationDetails?.attention }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr class="light-line" />
      <div class="payment-method">
        <!--payment-method with edit and remove-->
        <h3 class="titlepay">Payment method</h3>
        <ul>
          <li class="mb1">
            <a>
              <div class="d-flex">
                <div>
                  @if (paymentMethod != 'Bill me later') {
                    <img src="/icons/{{ baseSiteId }}/card.svg"
                      alt="" />
                  }
                  @if (paymentMethod == 'Bill me later') {
                    <img src="/icons/{{ baseSiteId }}/billing.png"
                      alt="" />
                  }
                </div>
                <div>
                  {{ paymentMethod }}<br />
                  @if (paymentMethod != 'Bill me later') {
                    <span class="font-regular">{{ paymentCardDetails }}</span>
                  }
                </div>
              </div>
            </a>
          </li>
        </ul>
        <p>
          If your reservation contains multiple shipments, please note that you
          will be billed per shipment.
        </p>
      </div>
      <hr class="light-line" />
      <div class="contact-details contact-data reserve-detail cursor-pointer"
        [ngClass]="iseditReservation === true ? 'hide' : ''">
        <h3 class="hideforPrint pop-alert">
          <span [ngbTooltip]="resContactPopover" [autoClose]="false" triggers="manual" #popover="ngbTooltip"
            (click)="openResContactPopover(popover)" title="">
            Reservation contact
          </span>
          <ng-template #resContactPopover>
            <p class="text-center mb-2 reservationContactText">
              Your reservation contact details and receiving hours must be
              accurate to ensure delivery
            </p>
            <div class="units-doses dismiss d-flex justify-content-center">
              <a style="background: url('/icons/{{baseSiteId}}/editIcon.png') 0 0/17px no-repeat padding-box !important;"
                class="edit-icon float-none" (click)="closeResContactPopover(popover)">
              Dismiss</a>
            </div>
          </ng-template>
        </h3>

        <div class="content">
          <p class="blue-text">
            This is who we'll contact for ongoing updates about this
            reservation.
          </p>
        </div>

        <div class="hide" id="reservation-detail">
          <h6 class="product_trash">
            <div class="content">
              Your reservation contact details and receiving hours must be
              accurate to ensure delivery.
            </div>
          </h6>
          <a href="javascript:void(0)" title="Dismiss" class="dismiss">Dismiss</a>
        </div>

        <div class="table-responsive hideforPrint succes-cont">
          <table class="table word_brk" role="presentation">
            <tbody>
              <tr>
                <td>Name</td>
                <td class="fluorder-contactname">
                  <span>{{ reservationDetails?.orderContactData?.name }}</span>
                </td>
              </tr>

              <tr>
                <td>Phone</td>
                <td class="fluorder-contactname">
                  <span>{{ reservationDetails?.orderContactData?.phoneNo }}</span>
                </td>
              </tr>

              <tr>
                <td class="faqs">
                  Mobile
                  <img src="/icons/{{ baseSiteId }}/faqs_reg.png" data-html="true"
                    data-original-title="image" placement="top" [ngbTooltip]="mobileTooltip"
                    (mouseenter)="closeResContactPopover(popover)" tooltipClass="mobiletooltip-popover" />
                  <ng-template #mobileTooltip>
                    <div class="content">
                      Message and data rates may apply.

                      <br /><br />
                      If you reply STOP to any Sanofi Pasteur order text
                      message, you will not receive any text messages to that
                      mobile phone from Sanofi Pasteur. If you wish to re-enroll
                      that mobile phone number, you must wait 30 days from the
                      day you replied STOP due to privacy and other regulations.
                      <br /><br />@if (baseSiteId == 'vsh') {
                      <span>Please contact 1-800-VACCINE (1-800-822-2463)
                      for further assistance.</span>
                    }
                    @if (baseSiteId == 'vax') {
                      <span>Please contact 1-800-752-9338
                      for further assistance.</span>
                    }
                  </div>
                </ng-template>
                <div class="content"></div>
              </td>

              <td class="ordrCntctMble">
                <span>{{
                  reservationDetails?.orderContactData?.mobileNo
                }}<br /></span>
                @if (reservationDetails?.orderContactData?.additionalMobiles) {
                  <span>
                    @for (mobile of reservationDetails?.orderContactData?.additionalMobiles; track mobile) {
                      <span>{{
                        mobile
                      }}<br /></span>
                    }
                  </span>
                }
              </td>
            </tr>

            @if (reservationDetails?.orderContactData?.email) {
              <tr class="email-cont">
                <td>Email</td>
                <td class="appendEmail">
                  <a href="#" target="_blank" [title]="reservationDetails?.orderContactData?.email">{{
                  reservationDetails?.orderContactData?.email }}</a><br />
                  @for (email of reservationDetails?.orderContactData?.additionalEmails; track email) {
                    <span>
                      <a href="#" target="_blank" [title]="email">{{ email }}</a><br />
                    </span>
                  }
                </td>
              </tr>
            }

            @if (reservationDetails?.orderContactData?.fax) {
              <tr>
                <td>Fax</td>
                <td>
                  <span>{{
                    reservationDetails?.orderContactData?.fax
                    }}<br />
                  </span>
                </td>
              </tr>
            }

            <tr>
              <td>Placed by</td>
              <td class="appendPlaceby">
                {{ reservationDetails?.orderContactData?.placedBy ? reservationDetails?.orderContactData?.placedBy :
                reservationDetails?.orderContactData?.name }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ul class="hideforPrint">
        <li>
          <h6>Billing address</h6>
          <p class="mb-0">
            Account number:
            {{ reservationDetails?.shipToParty?.billingAddress?.accountNumber }}
          </p>
          @if (reservationDetails?.shipToParty?.billingAddress?.companyName) {
            <p class="pt-0 mb-0">
              {{reservationDetails?.shipToParty?.billingAddress?.companyName}}
            </p>
          }

          <p class="pt-0 mb-0">{{ reservationDetails?.shipToParty?.billingAddress?.formattedAddress }}</p>
        </li>
        <li>
          <h6>Payer address</h6>
          <p class="mb-0">
            Account number:
            {{ reservationDetails?.shipToParty?.payerAddress?.accountNumber }}
          </p>
          @if (reservationDetails?.shipToParty?.payerAddress?.companyName) {
            <p class="pt-0 mb-0">
              {{ reservationDetails?.shipToParty?.payerAddress?.companyName }}
            </p>
          }

          <p class="pt-0 mb-0">{{ reservationDetails?.shipToParty?.payerAddress?.formattedAddress }}</p>
        </li>
      </ul>

      <div class="hideforNormal">
        <div>
          <h3>Reservation contact</h3>
        </div>
        <div>
          <span>This is who we'll contact for ongoing updates about this
          reservation.</span><br />
          <br />
        </div>
        <div>Name &nbsp;&nbsp;&nbsp;</div>
        <div>Fax &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
        <div>Email &nbsp;&nbsp;</div>
        <div>
          Placed by &nbsp;&nbsp;PMG THE PLAZA<br />
          <br />
        </div>
      </div>
      <div class="hideforNormal">
        <div class="printpadding10">
          <div>
            <b> Billing address</b>
          </div>
          <div>Account number:</div>
          <div></div>
          <div>,&nbsp;</div>
          <div>
            ,&nbsp;&nbsp;<br />
            <br />
          </div>
        </div>
        <div class="printpadding10">
          <div>
            <b>Ship To Address</b>
          </div>
          <div>Account number:</div>
          <div></div>
          <div>,&nbsp;</div>
          <div>,&nbsp;&nbsp;</div>
        </div>
      </div>
      <div class="mt-3 d-inline-block">
        <a target="_blank" class="link" title="Manage billing information" (click)="goToProfileAccount()">
          Manage billing information
        </a>
      </div>
    </div>

    <!-- contact edit -->
    <div class="contact-details contact-form" [ngClass]="iseditReservation === true ? '' : 'hide'"></div>
    <!-- end contact edit -->
    <hr class="light-line" />
    <section class="deliveryHours">
      <app-receiving-hours [fromModule]="'reservation-overview'" [deliveryTimings]="reservationDetails?.deliveryHours"
      fullWidth="True" (update)="updateDeliveryTimings($event)" [disableEdit]="editable"></app-receiving-hours>
    </section>
    <div id="reservation-popup" class="modal popup-comp vso-popup approvers-popup reservation-popup" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title-top20">Reservation locked</h4>
          </div>
          <div class="modal-body">
            <p class="content">
              Another user is currently editing this reservation. You will not
              be able to make changes at this time.
            </p>
          </div>
          <div class="modal-footer">
            <div class="change-request-btngrps">
              <button type="button" class="btn btn-default white-button cancel-btn" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </aside>
</div>
<div id="loading-checkout" class="modal popup-comp page-pre-loader" role="dialog" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="">
          <p class="reserve-text">Processing your request</p>
          <div class="progress2 progress-moved">
            <div class="progress-bar2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
